
  <div class="modal-header">
    <h5 class="modal-title" id="emptyModalLabel">Change Password</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">x</button>
  </div>
  <div class="modal-body">
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
      <!-- Current Password -->
      <div class="form-group">
        <label for="currentPassword">Current Password</label>
        <input type="password" id="currentPassword" formControlName="currentPassword" class="form-control" />
        <div *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched">
          <small class="error">Current password is required</small>
        </div>
      </div>
  
      <!-- New Password -->
      <div class="form-group">
        <label for="newPassword">New Password</label>
        <input type="password" id="newPassword" formControlName="newPassword" class="form-control" />
        <div *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched">
          <small class="error">New password is required</small>
        </div>
      </div>
  
      <!-- Confirm New Password -->
      <div class="form-group">
        <label for="confirmNewPassword">Confirm New Password</label>
        <input type="password" id="confirmNewPassword" formControlName="confirmNewPassword" class="form-control" />
        <div *ngIf="changePasswordForm.get('confirmNewPassword')?.invalid && changePasswordForm.get('confirmNewPassword')?.touched">
          <small class="error">Confirmation password must match new password</small>
        </div>
      </div>
  
      <button type="submit" [disabled]="changePasswordForm.invalid" class="btn btn-outline-primary">Change Password</button>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
   <!--  <button type="button" class="btn btn-outline-primary">Save changes</button> -->
  </div>
